import { Colors, DropdownListItem, FlexBox, MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";
import { ProjectEditPageGridAuthorRow, BilingWrapper, ProjectEditGrid, ColumnLabelGroup } from "../../styles";
import texttop from "../PresentatitonBlock/icons/textposition/texttop.svg"
import texttophover from "../PresentatitonBlock/icons/textposition/texttophover.svg"
import textdefault from "../PresentatitonBlock/icons/textposition/textdefault.svg"
import textdefaulthover from "../PresentatitonBlock/icons/textposition/textdefaulthover.svg"
import textcenter from "../PresentatitonBlock/icons/textposition/textcenter.svg"
import textcenterhover from "../PresentatitonBlock/icons/textposition/textcenterhover.svg"
import textbottom from "../PresentatitonBlock/icons/textposition/textbottom.svg"
import textbottomhover from "../PresentatitonBlock/icons/textposition/textbottomhover.svg"
import righttop from "../PresentatitonBlock/icons/textposition/righttop.svg"
import righttophover from "../PresentatitonBlock/icons/textposition/righttophover.svg"
import rightcenter from "../PresentatitonBlock/icons/textposition/rightcenter.svg"
import rightcenterhover from "../PresentatitonBlock/icons/textposition/rightcenterhover.svg"
import rightbottom from "../PresentatitonBlock/icons/textposition/rightbottom.svg"
import rightbottomhover from "../PresentatitonBlock/icons/textposition/rightbottomhover.svg"
import addpntextbottom from "../PresentatitonBlock/icons/textposition/addpntextbottom.svg"
import addpntextbottomhover from "../PresentatitonBlock/icons/textposition/addpntextbottomhover.svg"
import { QuestionButtonIcon } from "shared/features/QueuePaymenrt/payment/CheckOut/assets/QuestionButton";

export const ContentLabel = styled.div`
  color: ${({ theme }) => theme.projectEdit.btns.lang.biling.color};
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  white-space: pre-wrap;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const PresentationWrapper = styled(FlexBox) <{ hasCover?: boolean, isLms?: boolean }>`
    width: 100%;
    flex-flow: column;
    max-width: 1152px;
    margin: ${({ hasCover, isLms }) => hasCover ? '24px auto 0 auto' : isLms ? '0 auto' : '24px auto 0 auto'};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      margin: ${({ hasCover, isLms }) => hasCover ? '24px auto 0 auto' : isLms ? '0 auto' : '24px auto 0 auto'};
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
      margin: 24px auto 0 auto;
      width: 738px
    }
    @media(max-width: 800px) {
      width: 696px
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        margin: 0 auto 0 auto;
        width: 100%;
    }
`;

export const PresentationContainer = styled(FlexBox) <{ vtype: string }>`
    width: 100%;
    flex-flow: row;
    max-width: 1152px;
    background-color: ${p => p.theme.tags.cloud.background};
    //#2C2C2B
    padding: 24px 48px;

    .mobile__hide {
      flex-direction: column;
    }

    .color-picker-label {
        margin-bottom: 16px;
        padding-top: 0;

        width: 100%;
        min-width: 157px;
        height: auto;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: 888px;
        padding: 32px;
        margin: 0 auto;
        // ${({ vtype }) => ['fixed-ratio-large', 'fixed-ratio-small'].includes(vtype) ? css`
        //     padding: 16px;
        // ` : null};

        .user-color-choose {
            div {
                vertical-align: top;
                margin-top: 1px;
            }
        }

      .color-picker-label {
        margin-bottom: 16px;
        padding-top: 0;

        width: 135px;
        min-width: 115px;
      }
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        .mobile__hide {
            display: flex;
        }
        ${({ vtype }) => !['fixed-ratio-large', 'fixed-ratio-small'].includes(vtype) ? css`
        padding: 24px;
    ` : null};
    
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-flow: column;
        margin: 24px auto 0 auto;
        padding: 16px 10px;
        
    }

    @media(max-width: 375px) {
        margin: 24px auto 0 auto;
    }

    
`;

export const Left = styled(FlexBox) <{ vtype: string, gap?: number }>`
    flex-flow: column;
    width: 100%;
    margin-right: 40px;
    gap: ${({ gap }) => gap ? `${gap}px` : '24px'};

    .ui-input_container {
      background-color: ${p => p.theme.projectEdit.presentation.input.bg} !important;

      ${DropdownListItem} {
        background-color: ${p => p.theme.projectEdit.presentation.input.bg} !important;
        :hover {
          background-color: ${p => p.theme.projectEdit.presentation.input.dropdownHover} !important;
        }
      }
    }


    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      width: 100%;
      margin-right: 32px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        .coauthors-container {
          width: 100%;
        }
        width: 42%;
        max-width: none;
        margin-right: 32px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        max-width: none;
        padding-top: 0px;
        margin-bottom: 32px;
  
        .coauthors-container {
          width: 100%;
        }
    }
`;

export const LeftContent = styled(FlexBox)`
    flex-flow: column;
    width: 100%;
    gap: 24px;

     @media(max-width: ${LayoutConst.screen.md}px) {
        width: 100%;
        max-width: none;

        ${ContentLabel} {
          width: 100%;
          white-space: nowrap;
        }

        .add-button {
          width: 100%;
          min-width: auto;
          max-width: none;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      max-width: 100%;
  }
`;

export const Right = styled(Left)`
    width: 100%;
    margin-right: 0;

    input {
      background-color: #fff !important;
      width: 100%;
    }

    .coauthors-container {
      input {
        background-color: #fff;
      }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        width: 58%;
        max-width: none;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        max-width: none;
        padding-top: 0px;
    }
`;

export const CheckboxRoot = styled.div<{ checked?: boolean, isProjectPage?: boolean, isDeveloping?: boolean }>`
  width: 24px;
  height: 24px;
  min-width: 24px;
  border: 1px solid ${({ theme, isProjectPage, checked }) => (isProjectPage && checked) ? '#909090' : (isProjectPage && !checked) ? '#B6B6B5' : theme.projectEdit.btns.lang.biling.border};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, isProjectPage, isDeveloping }) => isDeveloping ? 'grey' : isProjectPage ? '#fefefe' : theme.projectEdit.btns.lang.biling.bg};
  input {
    display: none;
  }
`;

export const ErrorsContainer = styled(FlexBox)`
  flex-direction: column;
  gap: 16px;
  li {
    margin-bottom: 30px;
  }
`;

export const PickerWrapper = styled.div<{ isLMS?: boolean }>`
  max-width: ${({ isLMS }) => isLMS ? '488px' : '420px'};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 344px;
  }
`;

export const LMSLeft = styled(Left)`

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 376px;
    max-width: 376px;
    margin-right: 40px!important;
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    max-width: none;
    margin-right: 40px!important;
    input {
      background-color: background: ${Colors.galBlack5}!important;
    }
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    max-width: none;
    margin-right: 0!important;
    padding-top: 0!important;
  }
`
export const LMSLeftContent = styled(LeftContent)`
  max-width: 488px;
  width: 488px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 376px;
    max-width: 376px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    max-width: none;
  }
`
export const LMSRight = styled(Right)`
  max-width: 522px;

  ${ProjectEditPageGridAuthorRow} {
    margin-bottom: 0px;
  }


  input {
    max-width: 522px;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 388px;
    max-width: 388px;

    input {
      max-width: 376px;
    }


  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    max-width: none;
    input {
      background-color: ${Colors.galBlack5}!important;
    }
    input, .brg-input__control {
      max-width: none !important;
    }
  }
`;

export const ContentWrapper = styled(FlexBox) <{ isCompetitionEdit?: boolean, disableOffset?: boolean, disableRightOffset?: boolean }>`
  width: ${({ isCompetitionEdit }) => isCompetitionEdit ? '170px' : '100%'};
  min-width: ${({ isCompetitionEdit }) => isCompetitionEdit ? '170px' : '127px'};
  margin-right: ${({ isCompetitionEdit }) => isCompetitionEdit ? '32px' : '24px'};
  max-width: none;

  .add-button, .switcher-container {
    min-width: 400px;
  }

  input.competition-checkbox {
    
    width: 24px!important;
    height: 24px!important;
  }

  input ~ .competition-checkbox {
    // display: none;
    width: 24px;
    height: 24px;
    background: ${({ theme }) => theme.competition.input.checkbox.bg} !important;
    border-color: ${({ theme }) => theme.competition.input.checkbox.border} !important;
    
    svg {
      path {
        fill: ${({ theme }) => theme.competition.input.checkbox.icon};
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    ${({ isCompetitionEdit }) => isCompetitionEdit && css`
      width: 115px;
      min-width: 115px;
      margin-right: 24px;
    `};
    .add-button, .switcher-container {
      min-width: auto;
      max-width: none;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    ${({ disableRightOffset }) => disableRightOffset && css`
      margin-right: 0;
    `}
    max-width: none;
    width: 100%;
    min-width: auto;
    .add-button, .switcher-container {
      width: 100%;
      min-width: auto;
    }
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: ${({ isCompetitionEdit, disableOffset }) => (isCompetitionEdit || disableOffset) ? '0' : '16px'};
    
    .add-button, .switcher-container {
      width: 100%;
      min-width: auto;
      max-width: none;
    }
  }

  @media(max-width: 834px) {
    margin-right: ${({ isCompetitionEdit }) => isCompetitionEdit ? 'auto' : '24px'};
  }


  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    ${({ isCompetitionEdit }) => isCompetitionEdit ? css` 
      margin-right: 0;
      margin-bottom: 16px;
    ` : null};
  }
`;

export const HintLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  max-width: 1152px;
  margin: 0 auto 24px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 888px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    width: 738px;
  }

  @media(max-width: 800px) {
    width: 696px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
  }
`

export const HintLabel = styled.p`
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.34px;
  margin: 0;
  color: ${({ theme }) => theme.projectEdit.label};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`

export const SettingsLabel = styled.div`
  font-size: 20px;
  line-height: 25px;
  font-weight: 600;
  font-family: 'Inter';
  color: ${({ theme }) => theme.projectEdit.label};
`;


export const LocalPickerWrapper = styled(ProjectEditGrid)`
  .mobile__hide {
    gap: 8px;
    width: 180px;
  }

  .color-picker-label {
    margin: 0 !important;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    .color-picker-label {
      min-width: 124px;
    }
  }
`;


export const CountLength = styled.div`
  position: absolute;
  top: 50%;
  right: 16.5px;
  transform: translateY(-50%);
  color: #909090;
  font-size: 10px;
  width: 27px !important;
  line-height: 13px;
  font-weight: 400;

  @media(max-width: ${LayoutConst.screen.md}px) {
    display: none;
  }
`;
export const ColorButtonsWrapper = styled(FlexBox) <{ isProDeziiign?: boolean }>`
  flex-direction: column;
  gap: 16px 24px;
  ${MEDIA.TABLET} {
    flex-wrap: wrap;
    flex-direction: row;
  }
  
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column;
  }
   
`

export const AddBtnsCss = css`
  display: inline-block;
  width: 32px;
  height: 32px;
  cursor: pointer;
  transition: 0.2s;
  /* margin-right: 16px; */
  flex-shrink: 0;
  //vertical-align: middle;
`
export const AddTextDefault = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}
  background:  url(${({ active, current }) =>
    (active || current) ? textdefaulthover : textdefault}) no-repeat center;

  &:hover {
    background: url(${textdefaulthover}) no-repeat center;
  }
`;
export const AddTextTop = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}

  svg {
    path {
      fill: ${({theme, active}) => active? theme.viewType.item.active : theme.viewType.item.default};
    }
  }

  &:hover {
    svg {
      path {
        fill: ${({ theme }) => (theme.viewType.item.hover)};
      }
    }
  }
`;
export const AddTextCenter = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}
  background:  url(${({ active, current }) =>
    (active || current) ? textcenterhover : textcenter}) no-repeat center;

  &:hover {
    background: url(${textcenterhover}) no-repeat center;
  }
`;
export const AddTextBottom = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}

  svg {
    transform: scaleY(-1);
    path {
      fill: ${({theme, active}) => active? theme.viewType.item.active : theme.viewType.item.default};
    }
  }

  &:hover {
    svg {
      path {
        fill: ${({ theme }) => (theme.viewType.item.hover)};
      }
    }
  }
`;

export const AddPresentationRightTopBtn = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}
  background:  url(${({ active, current }) =>
    (active || current) ? righttophover : righttop}) no-repeat center;

  &:hover {
    background: url(${righttophover}) no-repeat center;
  }
`;
export const AddPresentationRightCenterBtn = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}
  background:  url(${({ active, current }) =>
    (active || current) ? rightcenterhover : rightcenter}) no-repeat center;

  &:hover {
    background: url(${rightcenterhover}) no-repeat center;
  }
`;
export const AddPresentationRightBottomBtn = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}
  background:  url(${({ active, current }) =>
    (active || current) ? rightbottomhover : rightbottom}) no-repeat center;

  &:hover {
    background: url(${rightbottomhover}) no-repeat center;
  }
`;

export const AnchorSettinsContainer = styled(FlexBox)`
  flex-flow: column;

  * {
    font-size: 13px;
    line-height: 16px;
    color: ${({ theme }) => theme.projectEdit.label};
  }
`;

export const CheckBoxInfoWrapper = styled(FlexBox)`

  .hint-info-icon {
    path {
      fill: #909090;
    }
  }
`;

export const HintIcon = styled.svg`
  transform: translateY(-1px);
`;
export const DefaultButton = styled.button`
    display: flex;
    place-items: center;
    justify-content: center;
    height: 40px;
    border: 1px solid rgba(182, 182, 181, 1);
    color: rgba(21, 21, 20, 1);
    font-size: 15px;
    font-family: 'Inter';
    line-height: 20px;
    outline: none;
    cursor: pointer;
    border-radius: 3px;
    font-weight: 400;
    background-color: rgba(254, 254, 254, 1);
    width: 127px;

    &:disabled {
        pointer-events: none;
        background-color: transparent !important;
        cursor: not-allowed;
        color: grey !important;
        border: none;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        max-width: 100%;
        width: 100%;
        min-width: auto;
        background-color: rgba(254, 254, 254, 1);
    }
`;

export const CoverSection = styled(ColumnLabelGroup)`
    align-items: flex-start;
`;

export const CoverLabel = styled.span`
    font-family: 'Inter', sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #909090;
`;

export const CoverAddBtn = styled.label`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 230px;
    height: 48px;
    border: 1px solid #151514;
    border-radius: 3px;
    background: transparent;
    cursor: pointer;
    font-family: Inter, sans-serif;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    color: #151514;
    white-space: nowrap;
    &:hover { background: #f2f2f2; }
`;

export const CoverFileNameRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    width: 100%;
    font-family: Inter, sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #909090;

    & > span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        min-width: 0;
    }
`;

export const CoverRemoveBtn = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    flex-shrink: 0;
    font-size: 15px;
    line-height: 20px;
    color: #909090;
    &:hover { opacity: 0.6; }
`;

export const CoverImg = styled.img`
    display: block;
    width: 270px;
    height: 142px;
    border-radius: 4px;
    object-fit: cover;
`;import { Colors, DropdownListItem, FlexBox, MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";
import { ProjectEditPageGridAuthorRow, BilingWrapper, ProjectEditGrid, ColumnLabelGroup } from "../../styles";
import texttop from "../PresentatitonBlock/icons/textposition/texttop.svg"
import texttophover from "../PresentatitonBlock/icons/textposition/texttophover.svg"
import textdefault from "../PresentatitonBlock/icons/textposition/textdefault.svg"
import textdefaulthover from "../PresentatitonBlock/icons/textposition/textdefaulthover.svg"
import textcenter from "../PresentatitonBlock/icons/textposition/textcenter.svg"
import textcenterhover from "../PresentatitonBlock/icons/textposition/textcenterhover.svg"
import textbottom from "../PresentatitonBlock/icons/textposition/textbottom.svg"
import textbottomhover from "../PresentatitonBlock/icons/textposition/textbottomhover.svg"
import righttop from "../PresentatitonBlock/icons/textposition/righttop.svg"
import righttophover from "../PresentatitonBlock/icons/textposition/righttophover.svg"
import rightcenter from "../PresentatitonBlock/icons/textposition/rightcenter.svg"
import rightcenterhover from "../PresentatitonBlock/icons/textposition/rightcenterhover.svg"
import rightbottom from "../PresentatitonBlock/icons/textposition/rightbottom.svg"
import rightbottomhover from "../PresentatitonBlock/icons/textposition/rightbottomhover.svg"
import addpntextbottom from "../PresentatitonBlock/icons/textposition/addpntextbottom.svg"
import addpntextbottomhover from "../PresentatitonBlock/icons/textposition/addpntextbottomhover.svg"
import { QuestionButtonIcon } from "shared/features/QueuePaymenrt/payment/CheckOut/assets/QuestionButton";

export const ContentLabel = styled.div`
  color: ${({ theme }) => theme.projectEdit.btns.lang.biling.color};
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  white-space: pre-wrap;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const PresentationWrapper = styled(FlexBox) <{ hasCover?: boolean, isLms?: boolean }>`
    width: 100%;
    flex-flow: column;
    max-width: 1152px;
    margin: ${({ hasCover, isLms }) => hasCover ? '24px auto 0 auto' : isLms ? '0 auto' : '24px auto 0 auto'};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      margin: ${({ hasCover, isLms }) => hasCover ? '24px auto 0 auto' : isLms ? '0 auto' : '24px auto 0 auto'};
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
      margin: 24px auto 0 auto;
      width: 738px
    }
    @media(max-width: 800px) {
      width: 696px
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        margin: 0 auto 0 auto;
        width: 100%;
    }
`;

export const PresentationContainer = styled(FlexBox) <{ vtype: string }>`
    width: 100%;
    flex-flow: row;
    max-width: 1152px;
    background-color: ${p => p.theme.tags.cloud.background};
    //#2C2C2B
    padding: 24px 48px;

    .mobile__hide {
      flex-direction: column;
    }

    .color-picker-label {
        margin-bottom: 16px;
        padding-top: 0;

        width: 100%;
        min-width: 157px;
        height: auto;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: 888px;
        padding: 32px;
        margin: 0 auto;
        // ${({ vtype }) => ['fixed-ratio-large', 'fixed-ratio-small'].includes(vtype) ? css`
        //     padding: 16px;
        // ` : null};

        .user-color-choose {
            div {
                vertical-align: top;
                margin-top: 1px;
            }
        }

      .color-picker-label {
        margin-bottom: 16px;
        padding-top: 0;

        width: 135px;
        min-width: 115px;
      }
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        .mobile__hide {
            display: flex;
        }
        ${({ vtype }) => !['fixed-ratio-large', 'fixed-ratio-small'].includes(vtype) ? css`
        padding: 24px;
    ` : null};
    
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-flow: column;
        margin: 24px auto 0 auto;
        padding: 16px 10px;
        
    }

    @media(max-width: 375px) {
        margin: 24px auto 0 auto;
    }

    
`;

export const Left = styled(FlexBox) <{ vtype: string, gap?: number }>`
    flex-flow: column;
    width: 100%;
    margin-right: 40px;
    gap: ${({ gap }) => gap ? `${gap}px` : '24px'};

    .ui-input_container {
      background-color: ${p => p.theme.projectEdit.presentation.input.bg} !important;

      ${DropdownListItem} {
        background-color: ${p => p.theme.projectEdit.presentation.input.bg} !important;
        :hover {
          background-color: ${p => p.theme.projectEdit.presentation.input.dropdownHover} !important;
        }
      }
    }


    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      width: 100%;
      margin-right: 32px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        .coauthors-container {
          width: 100%;
        }
        width: 42%;
        max-width: none;
        margin-right: 32px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        max-width: none;
        padding-top: 0px;
        margin-bottom: 32px;
  
        .coauthors-container {
          width: 100%;
        }
    }
`;

export const LeftContent = styled(FlexBox)`
    flex-flow: column;
    width: 100%;
    gap: 24px;

     @media(max-width: ${LayoutConst.screen.md}px) {
        width: 100%;
        max-width: none;

        ${ContentLabel} {
          width: 100%;
          white-space: nowrap;
        }

        .add-button {
          width: 100%;
          min-width: auto;
          max-width: none;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      max-width: 100%;
  }
`;

export const Right = styled(Left)`
    width: 100%;
    margin-right: 0;

    input {
      background-color: #fff !important;
      width: 100%;
    }

    .coauthors-container {
      input {
        background-color: #fff;
      }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        width: 58%;
        max-width: none;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        max-width: none;
        padding-top: 0px;
    }
`;

export const CheckboxRoot = styled.div<{ checked?: boolean, isProjectPage?: boolean, isDeveloping?: boolean }>`
  width: 24px;
  height: 24px;
  min-width: 24px;
  border: 1px solid ${({ theme, isProjectPage, checked }) => (isProjectPage && checked) ? '#909090' : (isProjectPage && !checked) ? '#B6B6B5' : theme.projectEdit.btns.lang.biling.border};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, isProjectPage, isDeveloping }) => isDeveloping ? 'grey' : isProjectPage ? '#fefefe' : theme.projectEdit.btns.lang.biling.bg};
  input {
    display: none;
  }
`;

export const ErrorsContainer = styled(FlexBox)`
  flex-direction: column;
  gap: 16px;
  li {
    margin-bottom: 30px;
  }
`;

export const PickerWrapper = styled.div<{ isLMS?: boolean }>`
  max-width: ${({ isLMS }) => isLMS ? '488px' : '420px'};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 344px;
  }
`;

export const LMSLeft = styled(Left)`

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 376px;
    max-width: 376px;
    margin-right: 40px!important;
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    max-width: none;
    margin-right: 40px!important;
    input {
      background-color: background: ${Colors.galBlack5}!important;
    }
  }
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    max-width: none;
    margin-right: 0!important;
    padding-top: 0!important;
  }
`
export const LMSLeftContent = styled(LeftContent)`
  max-width: 488px;
  width: 488px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 376px;
    max-width: 376px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    max-width: none;
  }
`
export const LMSRight = styled(Right)`
  max-width: 522px;

  ${ProjectEditPageGridAuthorRow} {
    margin-bottom: 0px;
  }


  input {
    max-width: 522px;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 388px;
    max-width: 388px;

    input {
      max-width: 376px;
    }


  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    max-width: none;
    input {
      background-color: ${Colors.galBlack5}!important;
    }
    input, .brg-input__control {
      max-width: none !important;
    }
  }
`;

export const ContentWrapper = styled(FlexBox) <{ isCompetitionEdit?: boolean, disableOffset?: boolean, disableRightOffset?: boolean }>`
  width: ${({ isCompetitionEdit }) => isCompetitionEdit ? '170px' : '100%'};
  min-width: ${({ isCompetitionEdit }) => isCompetitionEdit ? '170px' : '127px'};
  margin-right: ${({ isCompetitionEdit }) => isCompetitionEdit ? '32px' : '24px'};
  max-width: none;

  .add-button, .switcher-container {
    min-width: 400px;
  }

  input.competition-checkbox {
    
    width: 24px!important;
    height: 24px!important;
  }

  input ~ .competition-checkbox {
    // display: none;
    width: 24px;
    height: 24px;
    background: ${({ theme }) => theme.competition.input.checkbox.bg} !important;
    border-color: ${({ theme }) => theme.competition.input.checkbox.border} !important;
    
    svg {
      path {
        fill: ${({ theme }) => theme.competition.input.checkbox.icon};
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    ${({ isCompetitionEdit }) => isCompetitionEdit && css`
      width: 115px;
      min-width: 115px;
      margin-right: 24px;
    `};
    .add-button, .switcher-container {
      min-width: auto;
      max-width: none;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    ${({ disableRightOffset }) => disableRightOffset && css`
      margin-right: 0;
    `}
    max-width: none;
    width: 100%;
    min-width: auto;
    .add-button, .switcher-container {
      width: 100%;
      min-width: auto;
    }
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: ${({ isCompetitionEdit, disableOffset }) => (isCompetitionEdit || disableOffset) ? '0' : '16px'};
    
    .add-button, .switcher-container {
      width: 100%;
      min-width: auto;
      max-width: none;
    }
  }

  @media(max-width: 834px) {
    margin-right: ${({ isCompetitionEdit }) => isCompetitionEdit ? 'auto' : '24px'};
  }


  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    ${({ isCompetitionEdit }) => isCompetitionEdit ? css` 
      margin-right: 0;
      margin-bottom: 16px;
    ` : null};
  }
`;

export const HintLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  max-width: 1152px;
  margin: 0 auto 24px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 888px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    width: 738px;
  }

  @media(max-width: 800px) {
    width: 696px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
  }
`

export const HintLabel = styled.p`
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.34px;
  margin: 0;
  color: ${({ theme }) => theme.projectEdit.label};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`

export const SettingsLabel = styled.div`
  font-size: 20px;
  line-height: 25px;
  font-weight: 600;
  font-family: 'Inter';
  color: ${({ theme }) => theme.projectEdit.label};
`;


export const LocalPickerWrapper = styled(ProjectEditGrid)`
  .mobile__hide {
    gap: 8px;
    width: 180px;
  }

  .color-picker-label {
    margin: 0 !important;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    .color-picker-label {
      min-width: 124px;
    }
  }
`;


export const CountLength = styled.div`
  position: absolute;
  top: 50%;
  right: 16.5px;
  transform: translateY(-50%);
  color: #909090;
  font-size: 10px;
  width: 27px !important;
  line-height: 13px;
  font-weight: 400;

  @media(max-width: ${LayoutConst.screen.md}px) {
    display: none;
  }
`;
export const ColorButtonsWrapper = styled(FlexBox) <{ isProDeziiign?: boolean }>`
  flex-direction: column;
  gap: 16px 24px;
  ${MEDIA.TABLET} {
    flex-wrap: wrap;
    flex-direction: row;
  }
  
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column;
  }
   
`

export const AddBtnsCss = css`
  display: inline-block;
  width: 32px;
  height: 32px;
  cursor: pointer;
  transition: 0.2s;
  /* margin-right: 16px; */
  flex-shrink: 0;
  //vertical-align: middle;
`
export const AddTextDefault = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}
  background:  url(${({ active, current }) =>
    (active || current) ? textdefaulthover : textdefault}) no-repeat center;

  &:hover {
    background: url(${textdefaulthover}) no-repeat center;
  }
`;
export const AddTextTop = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}

  svg {
    path {
      fill: ${({theme, active}) => active? theme.viewType.item.active : theme.viewType.item.default};
    }
  }

  &:hover {
    svg {
      path {
        fill: ${({ theme }) => (theme.viewType.item.hover)};
      }
    }
  }
`;
export const AddTextCenter = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}
  background:  url(${({ active, current }) =>
    (active || current) ? textcenterhover : textcenter}) no-repeat center;

  &:hover {
    background: url(${textcenterhover}) no-repeat center;
  }
`;
export const AddTextBottom = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}

  svg {
    transform: scaleY(-1);
    path {
      fill: ${({theme, active}) => active? theme.viewType.item.active : theme.viewType.item.default};
    }
  }

  &:hover {
    svg {
      path {
        fill: ${({ theme }) => (theme.viewType.item.hover)};
      }
    }
  }
`;

export const AddPresentationRightTopBtn = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}
  background:  url(${({ active, current }) =>
    (active || current) ? righttophover : righttop}) no-repeat center;

  &:hover {
    background: url(${righttophover}) no-repeat center;
  }
`;
export const AddPresentationRightCenterBtn = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}
  background:  url(${({ active, current }) =>
    (active || current) ? rightcenterhover : rightcenter}) no-repeat center;

  &:hover {
    background: url(${rightcenterhover}) no-repeat center;
  }
`;
export const AddPresentationRightBottomBtn = styled.div<{ active?: boolean, current?: boolean }>`
  ${AddBtnsCss}
  background:  url(${({ active, current }) =>
    (active || current) ? rightbottomhover : rightbottom}) no-repeat center;

  &:hover {
    background: url(${rightbottomhover}) no-repeat center;
  }
`;

export const AnchorSettinsContainer = styled(FlexBox)`
  flex-flow: column;

  * {
    font-size: 13px;
    line-height: 16px;
    color: ${({ theme }) => theme.projectEdit.label};
  }
`;

export const CheckBoxInfoWrapper = styled(FlexBox)`

  .hint-info-icon {
    path {
      fill: #909090;
    }
  }
`;

export const HintIcon = styled.svg`
  transform: translateY(-1px);
`;
export const DefaultButton = styled.button`
    display: flex;
    place-items: center;
    justify-content: center;
    height: 40px;
    border: 1px solid rgba(182, 182, 181, 1);
    color: rgba(21, 21, 20, 1);
    font-size: 15px;
    font-family: 'Inter';
    line-height: 20px;
    outline: none;
    cursor: pointer;
    border-radius: 3px;
    font-weight: 400;
    background-color: rgba(254, 254, 254, 1);
    width: 127px;

    &:disabled {
        pointer-events: none;
        background-color: transparent !important;
        cursor: not-allowed;
        color: grey !important;
        border: none;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        max-width: 100%;
        width: 100%;
        min-width: auto;
        background-color: rgba(254, 254, 254, 1);
    }
`;

export const CoverSection = styled(ColumnLabelGroup)`
    align-items: flex-start;
`;

export const CoverLabel = styled.span`
    font-family: 'Inter', sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #909090;
`;

export const CoverAddBtn = styled.label`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 230px;
    height: 48px;
    border: 1px solid #151514;
    border-radius: 3px;
    background: transparent;
    cursor: pointer;
    font-family: Inter, sans-serif;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    color: #151514;
    white-space: nowrap;
    &:hover { background: #f2f2f2; }
`;

export const CoverFileNameRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    width: 100%;
    font-family: Inter, sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: #909090;

    & > span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        min-width: 0;
    }
`;

export const CoverRemoveBtn = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    flex-shrink: 0;
    font-size: 15px;
    line-height: 20px;
    color: #909090;
    &:hover { opacity: 0.6; }
`;

export const CoverImg = styled.img`
    display: block;
    width: 270px;
    height: 142px;
    border-radius: 4px;
    object-fit: cover;
`;